import {
  CLEAN_DETAIL_LIST_FREE_TRIAL_IPB,
  CLEAN_DETAIL_LIST_FREE_TRIAL_IPB_ERROR,
} from '_models/redux/types';

export const cleanDetailFreeTrialIpbAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_LIST_FREE_TRIAL_IPB,
    });
  } catch {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_LIST_FREE_TRIAL_IPB_ERROR,
    });
  }
};
